import React, { PropsWithChildren } from "react";
import { useSessionStorage } from "usehooks-ts";
import {
  OIDCAuthProvider,
  POST_LOGIN_REDIRECT_KEY,
  SIGN_IN_CALLBACK_URL,
  WebStorageStateStore,
} from "shared-auth";
import { config } from "../../../../config";

const oidcConfig = {
  authority: config.oidc?.authority,
  client_id: config.oidc?.clientId,
  scope: config.oidc?.scope,
  response_type: "code",
  redirect_uri: `${config.frontEndUrl}/${SIGN_IN_CALLBACK_URL}`,
  post_logout_redirect_uri: config.portalApiLogoutUrl,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  loadUserInfo: true,
};

interface Props {
  extraQueryParams?: Record<string, string>;
}

const AuthProvider = ({
  extraQueryParams,
  children,
}: PropsWithChildren<Props>) => {
  const [postLoginRedirect] = useSessionStorage<string>(
    POST_LOGIN_REDIRECT_KEY,
    config.frontEndUrl
  );

  return (
    <OIDCAuthProvider
      {...oidcConfig}
      automaticSilentRenew={false}
      extraQueryParams={extraQueryParams}
      onSigninCallback={() => window.location.replace(postLoginRedirect)}
    >
      {children}
    </OIDCAuthProvider>
  );
};

export default AuthProvider;
